<template>
  <pull-to class="eds-work-root" :top-load-method="onRefresh" @infinite-scroll="onAppend"
    :top-config="TOP_DEFAULT_CONFIG" :bottom-config="BOTTOM_DEFAULT_CONFIG">
    <div v-if="taskListStatus === 0" class="task-list-loading">
      <div class="task-list-loading__inner">
        <div class="task-list-loading-animation"></div>
        <div class="task-list-loading-text">{{ $t('正在载入') }}</div>
      </div>
    </div>
    <div v-else-if="taskListStatus !== 200" class="task-list-error-message">
      <div class="task-list-error-message__inner">
        <div class="task-list-error-message-text">{{ taskListMessage }}</div>
        <v-btn class="task-list-error-message-retry-btn" @click="onRefresh(null)">{{ $t('重试') }}</v-btn>
      </div>
    </div>
    <v-expansion-panel v-model="panels" expand>
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>{{ $t('常用功能：') }}</div>
        </template>
        <ul class="icons-ul">
          <li class="icons-li" v-for="item of contents_items" :key="item.id">
            <template v-if="item.title == '我的任务'">
              <v-badge color="red">
                <div class="icons-link" @click="Go(item)">
                  <div class="icons-img-wrap">
                    <img class="icons-img" :src="item.icon" alt />
                  </div>
                  <span class="icons-title">{{ $t(item.title) }}</span>
                </div>
                <span v-if="awaitingTaskTotalCount != 0" slot="badge">{{
                  awaitingTaskTotalCount > 99 ? '99+' : awaitingTaskTotalCount
                }}</span>
              </v-badge>
            </template>
            <template v-else>
              <div class="icons-link" @click="Go(item)">
                <div class="icons-img-wrap">
                  <img class="icons-img" :src="item.icon" alt />
                </div>
                <span class="icons-title">{{ $t(item.title) }}</span>
              </div>
            </template>
          </li>
        </ul>
      </v-expansion-panel-content>
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>{{ $t('最近要处理的任务：') }}</div>
        </template>
        <div class="eds_no_info_outer" v-if="!taskList || taskList.length == 0">
          <div class="eds_no_info_inner">
            <img src="imgs/svg/eds/no_task.svg" />
            <div>{{ $t('暂无任务') }}</div>
          </div>
        </div>
        <div v-for="(task, index) in taskList" :key="index">
          <template v-if="isEDS16()">
            <eDSCompTaskInfo16 class="eds-comp-task-info" :taskInfo="task" />
          </template>
          <template v-else>
            <eDSCompTaskInfo class="eds-comp-task-info" :taskInfo="task" />
          </template>
          <v-divider></v-divider>
        </div>
        <div v-if="!isDefault" class="eds_loading_bar">
          <span>{{ loadingText }}</span>
        </div>
        <iDS-GoTop></iDS-GoTop>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </pull-to>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import PullTo from 'vue-pull-to'
import APP_CONFIG from '../../config/App'
import dbHelper from '../../util/db'
import debugHelper from '../../util/debug'
import tools from '../../util/tools'
import msgbus from '../../msgBus'
import functions from '../../functions'
import eDSCompTaskInfo from '../../components/eDSCompTaskInfo'
import eDSCompTaskInfo16 from '../../components/eDSCompTaskInfo16'
import iDSGoTop from '../../components/iDSGoTop'

export default {
  name: 'eDS-Work',
  components: {
    PullTo,
    eDSCompTaskInfo,
    eDSCompTaskInfo16,
    iDSGoTop,
  },
  data() {
    return {
      TOP_DEFAULT_CONFIG: APP_CONFIG.tTOP_DEFAULT_CONFIG(),
      BOTTOM_DEFAULT_CONFIG: APP_CONFIG.tBOTTOM_DEFAULT_CONFIG(),
      tid: '',
      tname: '',
      tlogo: '',
      panels: [true, true],
      show: true,

      event: '',
      pageIndex: 0, // 页码
      pageSize: 5, // 每页记录数
      taskListRecordCount: 0, // 已经加载的总记录数
      loadingText: '',

      // 常用功能
      contents_items: [
        {
          id: 'mytask',
          title: '我的任务',
          icon: 'imgs/svg/eds/icon_mytask.svg',
          color: '',
          url: 'approval',
          urlParams: { activeTabName: 'tabMyTask' },
        },
        {
          id: 'myapplication',
          title: '我的申请',
          icon: 'imgs/svg/eds/icon_myapplication.svg',
          color: '',
          url: 'approval',
          urlParams: { activeTabName: 'tabMyApplication' },
        },
      ],
    }
  },
  computed: {
    isDefault() {
      return this.taskList == null || this.taskList.length == 0
    },
    taskList() {
      return msgbus.vm.getUserTasks()
    },
    taskListStatus() {
      return msgbus.vm.getUserTasksStatus()
    },
    taskListMessage() {
      return msgbus.vm.getUserTasksMessage()
    },
    totalCount() {
      return msgbus.vm.getUserTaskTotalCount()
    },
    awaitingTaskTotalCount() {
      return msgbus.vm.getUserAwaitingTaskTotalCount()
    },
  },
  methods: {
    isEDS16() {
      return msgbus.vm.isEDS16()
    },
    // 功能页面跳转
    Go(item) {
      this.$router.push({ name: item.url, params: item.urlParams })
    },
    // 刷新
    onRefresh(loaded) {
      // 初始加载0条记录
      this.taskListRecordCount = 0
      msgbus.vm.setTaskListRecordCount({ value: 0 })

      functions.work.funcFetchTaskForBadge(msgbus.vm, null)

      if (this.userTasksController) {
        this.userTasksController.abort()
        this.userTasksController = undefined
      }
      const userTasksController = new AbortController()
      this.userTasksController = userTasksController

      // 刷新显示信息
      msgbus.vm
        .fetchUserTasks({
          authorization: {
            Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
          },
          tid: msgbus.vm.getCurrentTenantID(),
          data: this.getFetchParams(),
          vm: msgbus.vm,
          signal: userTasksController.signal,
        })
        .then(
          () => {
            if (this.userTasksController === userTasksController) {
              this.userTasksController = undefined
            }

            this.taskListRecordCount += this.pageSize
            msgbus.vm.setTaskListRecordCount({
              value: this.taskListRecordCount,
            })
            if (loaded != null) {
              loaded('done')
            }
          },
          () => {
            if (this.userTasksController === userTasksController) {
              this.userTasksController = undefined
            }
            if (loaded != null) {
              loaded('fail')
            }
          }
        )
    },
    // 翻页
    onAppend(loaded) {
      if (this.taskListRecordCount < this.totalCount) {
        this.loadingText = this.$t('加载中...')
        msgbus.vm
          .appendUserTasks({
            authorization: {
              Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
            },
            tid: msgbus.vm.getCurrentTenantID(),
            data: this.getFetchParams(),
            vm: msgbus.vm,
          })
          .then(
            () => {
              this.taskListRecordCount += this.pageSize
              msgbus.vm.setTaskListRecordCount({
                value: this.taskListRecordCount,
              })
              if (loaded != null) {
                loaded('done')
              }
            },
            () => {
              if (loaded != null) {
                loaded('fail')
              }
            }
          )
      } else {
        if (loaded != null) {
          loaded('fail')
        }
        this.loadingText = this.$t('已经到底了')
      }
    },
    // 获取查询参数
    getFetchParams() {
      if (msgbus.vm.isEDS16()) {
        let filter = {
          state: 'awaiting', // 最近任务强制查询：未处理 
          nodeType: 'approve', // 强制查询：审批任务
        }
        var data = {
          order: '-createdAt',
          skip: this.taskListRecordCount,
          limit: this.pageSize,
          filter: JSON.stringify(filter)
        }
      } else {
        data = {
          state: 'awaiting', // 最近任务强制查询：未处理
          type: 'approval', // 强制查询：审批任务
          order: '-createTime',
          skip: this.taskListRecordCount,
          limit: this.pageSize,
        }
      }
      return data
    },

    // 切换界面样式
    changeView() {
      msgbus.vm.setMenuDisabled(true)
      msgbus.vm.setBackDisabled(true)
      msgbus.vm.setBackIcon('')
      msgbus.vm.setBottomNavVisible(true)
      msgbus.vm.setBottomBtnVisible(false)

      msgbus.vm.setContentHeight({
        value:
          `calc(${window.innerHeight
          }px - 48px - ${msgbus.vm.getContentBottomHeight()} ` + ')',
      })
    },

    // 设置租户信息
    setTenant() {
      // 读取租户信息
      var tenants = msgbus.vm.getAccountTenants()
      if (tenants) {
        this.tid = msgbus.vm.getCurrentTenantID()
        this.tname = msgbus.vm.getCurrentTenantName()
        this.tlogo = msgbus.vm.getCurrentTenantLogo()
        if (tenants.length == 1) {
          // 单租户
          msgbus.vm.setTitleList({
            visible: false,
            list: [],
            listIcon: [],
            change: () => { },
            curValue: '',
            curIcon: '',
          })
          msgbus.vm.setTitleAndIcon({ title: this.tname, icon: this.tlogo })
          msgbus.vm.setTitleVisible(true)
        } else if (tenants.length > 1) {
          // 多租户
          msgbus.vm.setTitleVisible(false)
          // 设置标题列表, 以提供切换功能
          var tenantsNameList = []
          var tenantsIconList = []
          tenants.forEach((tenant) => {
            tenantsNameList.push(tenant.name)
            tenantsIconList.push({ name: tenant.name, icon: tenant.logo })
          })
          msgbus.vm.setTitleList({
            visible: true,
            list: tenantsNameList,
            listIcon: tenantsIconList,
            change: this.changeTenant,
            curValue: this.tname,
            curIcon: this.tlogo,
          })
        }
      } else {
        // 无租户
        msgbus.vm.setTitleList({
          visible: false,
          list: [],
          listIcon: [],
          change: () => { },
          curValue: '',
          curIcon: '',
        })
        msgbus.vm.setTitle('')
        msgbus.vm.setTitleVisible(true)
      }
    },

    // 切换租户
    changeTenant(selectTenantName) {
      var tenants = msgbus.vm.getAccountTenants()
      var tenantTemp = tenants.filter(
        (tenant) => tenant.name == selectTenantName
      )[0]
      this.tid = tenantTemp.id
      this.tname = tenantTemp.name
      this.tlogo = tenantTemp.logo
      msgbus.vm.setCurrentTenant({
        tid: tenantTemp.id,
        tname: tenantTemp.name,
        tlogo: tenantTemp.logo,
        tserviceAPI: tenantTemp.serviceAPI,
        tserviceVersion: tenantTemp.serviceVersion,
      })

      // 工作页切换租户
      msgbus.vm.workSwitchTenant()

      // 刷新用户信息
      msgbus.vm
        .fetchUserInfo({
          tid: msgbus.vm.getCurrentTenantID(),
          vm: msgbus.vm,
          authorization: {
            Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
          },
        })
        .then(
          () => {
            // 刷新租户的最近任务列表
            this.onRefresh()
          },
          (err) => {
            // 注：若代码走到这里，界面上会一直显示正在载入
            err.type = 'error'
            err.prefix = 'work:'
            const tips = tools.parseTips(err)
            if (err.message !== 'canceled') {
              msgbus.vm.setUserTasks({
                value: {
                  status: 400,
                  message: (tips || {}).text || err,
                },
              })
            }
          }
        )
    },
  },
  created() {
    console.log('调试代码')
    if (msgbus.vm.getAccountToken() == null) {
      window.location.href = '/'
      return
    }

    // 切换界面样式
    this.changeView()

    // 界面显示租户信息
    this.setTenant()

    // 显示信息
    this.onRefresh()
  },
  mounted() {
    debugHelper.log(this.event)
    switch (this.event) {
      case 'updateScrollTop':
        var scroll = document.getElementsByClassName('scroll-container')[0]
        var Top = dbHelper.get('taskListScrollTop')
        debugHelper.log('获取scrollTop : ' + Top)
        scroll.scrollTop = Top
        dbHelper.set('taskListScrollTop', 0)
        dbHelper.set('taskListRecordCount', 0)
        break
    }
    this.event = ''
  },
  updated() {
    debugHelper.log(this.event)
    switch (this.event) {
      case 'updateScrollTop':
        var scroll = document.getElementsByClassName('scroll-container')[0]
        var Top = dbHelper.get('taskListScrollTop')
        debugHelper.log('获取scrollTop : ' + Top)
        scroll.scrollTop = Top
        dbHelper.set('taskListScrollTop', 0)
        dbHelper.set('taskListRecordCount', 0)
        break
    }
    this.event = ''
  },
  beforeDestroy() {
    if (this.userTasksController) {
      this.userTasksController.abort()
      this.userTasksController = undefined
    }
    msgbus.vm.setTitleList({
      visible: false,
      list: [],
      listIcon: [],
      change: () => { },
      curValue: '',
      curIcon: '',
    })
  },
}
</script>

<style lang="scss">
.eds-work-root {
  &>.scroll-container {
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: #f3f4f6;

    &>.v-expansion-panel {
      flex: 1;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      box-shadow: none !important;

      &>.v-expansion-panel__container {
        flex: 1;
        display: flex;
        flex-direction: column;

        &:first-child {
          flex: none;
          display: block;
        }

        &>.v-expansion-panel__body {
          flex: 1;
          display: flex;
          flex-direction: column;

          &>.eds_no_info_outer {
            flex: 1;
            display: block;
            position: relative;

            &>.eds_no_info_inner {
              display: inline-block;
              position: relative;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }
      }
    }
  }

  .v-expansion-panel__header {
    padding: 12px 14px;

    &> :not(.v-expansion-panel__header__icon) {
      flex: none !important;
    }
  }

  .icons-ul {
    margin: 6px 10px 20px 10px;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
  }

  .icons-li {
    flex: 0 1 25% !important;
    margin: 5px 0;
    list-style-type: none;
    text-align: center;
  }

  .icons-link {
    display: flex;
    align-items: center;
    flex-direction: column;
    color: #5a5a5a;
    text-decoration: none;
  }

  .icons-img-wrap {
    background-color: #1d80dd;
    border-radius: 10px;
    padding: 8px;
    height: 40px;
  }

  .icons-img {
    height: 24px;
    width: 24px;
  }

  .icons-title {
    font-size: 12px;
    margin-top: 4px;
  }

  .v-badge__badge {
    font-size: 10px;
    padding: 0 4px;
    top: -6px;
    right: -8px;
    width: auto;
    min-width: 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 10px;
    border: 1px solid #fff !important;
  }

  .eds-comp-task-info {
    margin-left: 12px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  & .task-list-loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    padding-top: 0;
    background-color: rgba(255, 255, 255, 1);

    &>.task-list-loading__inner {
      text-align: center;

      &>.task-list-loading-animation {
        display: inline-block;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        border: 8px solid lightgray;
        border-right-color: rgb(30, 136, 229);
        animation: rotating 1s infinite linear;
      }

      &>.task-list-loading-text {
        color: #909399;
        margin-top: 8px;
      }
    }
  }

  & .task-list-error-message {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    padding-top: 0;
    background-color: #ffffff;

    &>.task-list-error-message__inner {
      text-align: center;

      &>.task-list-error-message-text {
        color: #909399;
        font-size: 18px;
        line-height: 60px;
      }

      &>.task-list-error-message-retry-btn {
        color: #909399;
      }
    }
  }
}

@keyframes rotating {
  to {
    transform: rotate(1turn);
  }
}

@media screen and (min-width: 360px) {
  .eds-work-root {
    .icons-li {
      flex: 0 1 20%;
    }

    .icons-img-wrap {
      border-radius: 12px;
      padding: 8px;
      height: 46px;
    }

    .icons-img {
      height: 30px;
      width: 30px;
    }
  }
}

@media screen and (min-width: 440px) {
  .eds-work-root {
    .icons-li {
      flex: 0 1 16.66%;
    }
  }
}

@media screen and (min-width: 520px) {
  .eds-work-root {
    .icons-li {
      flex: 0 1 14.28%;
    }
  }
}

@media screen and (min-width: 600px) {
  .eds-work-root {
    .icons-li {
      flex: 0 1 12.5%;
    }
  }
}

@media screen and (min-width: 680px) {
  .eds-work-root {
    .icons-li {
      flex: 0 1 11.11%;
    }
  }
}

@media screen and (min-width: 760px) {
  .eds-work-root {
    .icons-li {
      flex: 0 1 10%;
    }
  }
}
</style>
